import {ModelStewardApi, UserBaseDTO} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const modelViewersApi = new ModelStewardApi(configuration);

export const requestModelStewardSet = (modelUuid: string, modelSteward: UserBaseDTO) =>
  modelViewersApi.setModelSteward({modelUuid: modelUuid, updateModelStewardDTO: {userId: modelSteward.id}});
